import { IRealityCheckData } from "../../../core/src/server/data/IRealityCheckData";
import PointerEvents from "../const/PointerEvents";
import CommManager from "../controllers/CommManager";
import BetModel from "../model/BetModel";
import GameModel from "../model/GameModel";
import { ICurrencyFormatConf } from "../model/ICurrency";
import RealityCheckModel from "../model/RealityCheckModel";
import RequestRegister from "../server/requests/RequestRegister";
import UIController from "../ui/UIController";
import { UIStates } from "../ui/UIStates";
import { DefaultLayers } from "../utils/Layers";
import Locale from "../utils/Locale";
import ViewManager from "../utils/ViewManager";
import { State } from "./State";
import CommandManager from "../commands/CommandManager";
import { Commands } from "../commands/CommandEnum";
import ErrorModel from "../model/ErrorModel";

const currencyConfig: ICurrencyFormatConf = {
    showIdentifier: true,
    showSymbol: true,
    prependSymbol: true,
    identifierSpaceCount: 1,
};

export class RealityCheckState extends State {
    constructor(stateMachine) {
        super(stateMachine);
    }

    public enter() {
        console.log("[Core][RealityCheckState] Enter()");
        super.enter();
        this.initRealityCheck();
    }

    protected initRealityCheck() {
        UIController.setState(UIStates.SPIN);
        CommandManager.execute(Commands.CLOSE_SETTINGS);
        if (GameModel.urlParams.rcshowresult == "true") {
            CommManager.send(RequestRegister.get("sessionResult"), (data)=> {
                RealityCheckModel.totalBet = data.betamount;
                RealityCheckModel.totalWin = data.winamount;
                this.showRealityCheck();
            }, true)
        } else {
            this.showRealityCheck();
        }
        // Show dark overlay

    }

    protected showRealityCheck() {
        ViewManager.getLayer("SplashOverlay").setScene("open");


        const elapsedTime = RealityCheckModel.milliSecToMin(
            RealityCheckModel.getElapsedTime()
        );
        const scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(
            "realityCheck"
        );

        // Set title label
        scene.sceneTextFields.get("title").text = Locale.getString(
            "rc_title_session_length"
        );

        // Set message body
        let messageBody = "";

        messageBody +=
            Locale.getString("rc_session_tie") +
            ": " +
            elapsedTime.min +
            Locale.getString("reality_check_minutes") +
            "\n\n";
        messageBody +=
            Locale.getString("rc_loss_amount") +
            ": " +
            BetModel.formatCurrency(
                RealityCheckModel.totalBet,
                currencyConfig
            ) +
            "\n\n";
        messageBody +=
            Locale.getString("rc_win_amount") +
            ": " +
            BetModel.formatCurrency(
                RealityCheckModel.totalWin,
                currencyConfig
            ) +
            "\n\n";

        scene.sceneTextFields.get("text").text = messageBody;

        // Set continue button
        const exitButton = scene.buttons.get("continue");
        exitButton.setValue(Locale.getString("but_cp"));
        exitButton.on(PointerEvents.DOWN, () => {
            ViewManager.getLayer(DefaultLayers.Popups).clear();

            // Clear limit
            CommManager.send(
                RequestRegister.get("resetRealityCheck"),
                (data) => {
                    console.log("[AuthState] Reset RC response", data);
                    // Also reset the model
                    RealityCheckModel.update(<IRealityCheckData>{
                        sessionMinutes: 0
                    });

                    // Hide the overlay
                    ViewManager.getLayer("SplashOverlay").clear();

                    // Then exit the state
                    this.exit();
                },
                this,
                (err)=>{
                    this.handleError(err);
                }
            );
        });

        // Set lobby button
        const lobbyButton = scene.buttons.get("lobby");
        lobbyButton.setValue(Locale.getString("but_rl"));
        lobbyButton.on(PointerEvents.DOWN, () => {
            ViewManager.getLayer(DefaultLayers.Popups).clear();
            CommandManager.execute(Commands.GO_HOME);

            // Then exit the state
            this.exit();
        });

        // Set account history button
        const historyButton = scene.buttons.get("history");
        historyButton.setValue(Locale.getString("but_ah"));

        if (GameModel.urlParams.rchistoryurl) {
            historyButton.on(PointerEvents.DOWN, () => {
                ViewManager.getLayer(DefaultLayers.Popups).clear();
                CommandManager.execute(Commands.OPEN_RC_HISTORY);

                // Then exit the state
                this.exit();
            });
        } else {
            historyButton.setVisible(false);
        }
    }

    handleError(err){
        ErrorModel.update(err);
        this.exit();
    }
}
